export default __webpack_public_path__ + "static/media/carvana_blue_logo.59aa18ff.png";